export default __webpack_public_path__ + "static/media/selectbgimg.d0f253d1.png";